import { Field, FormikProps } from "formik";
import ValidationError from "./ValidationError";
import TogglePlusMinus from "../TogglePlusMinus";

interface IFormTextGroupProps<T> extends React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
> {
  formik: FormikProps<T>;
  id: string;
  toggleMinus?: string;
  validationError?: string;
  validationTouched?: boolean;
  disabled?: boolean;
}

export function FormTextGroup<T>(props: IFormTextGroupProps<T>) {
  const {
    placeholder,
    id,
    formik,
    type,
    className,
    toggleMinus,
    validationError,
    validationTouched,
    disabled,
    ...rest
  } = props;
  return (
    <div className="input-group position-relative">
      {toggleMinus ? <TogglePlusMinus name={toggleMinus} /> : ""}
      {validationError && validationTouched ? (
        <>
          <Field
            name={id}
            id={id}
            placeholder={placeholder ? placeholder : "0"}
            autoComplete="off"
            {...rest}
            className={`form-control text-end${
              validationTouched && validationError ? " is-invalid" : ""
            }${className ? ` ${className}` : ""}`}
            type={type ? type : "text"}
            disabled={disabled}
          />
          <span className="input-group-text">kr</span>
          <ValidationError error={validationError} show={validationTouched} />
        </>
      ) : (
        <>
          <Field
            name={id}
            id={id}
            placeholder={placeholder ? placeholder : "0"}
            autoComplete="off"
            {...rest}
            className={`form-control text-end${
              formik.touched?.[id] && formik.errors?.[id] ? " is-invalid" : ""
            }${className ? ` ${className}` : ""}`}
            type={type ? type : "text"}
            disabled={disabled}
          />
          <span className="input-group-text">kr</span>
          <ValidationError
            error={formik.errors?.[id]}
            show={formik.touched?.[id]}
          />
        </>
      )}
    </div>
  );
}
